import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";

let _cache = null;

// Resolves the current user's permissions (server-authoritative). UI gating is
// convenience only — the backend enforces every action.
export function usePermissions() {
  const [data, setData] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    let active = true;
    if (_cache) { setData(_cache); setLoading(false); return; }
    apiFetch("/me/permissions")
      .then((d) => { _cache = d; if (active) { setData(d); } })
      .catch(() => { if (active) setData({ role: "", is_admin: false, is_owner: false, permissions: [] }); })
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const has = (perm) => !!data && (data.is_owner || (data.permissions || []).includes(perm));
  return { ...(data || { permissions: [], is_admin: false, is_owner: false }), has, loading };
}
